var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var SearchForm = createReactClass({
    mixins: [PureRenderMixin],

    handleSubmit: function(e){
        e.preventDefault();
        this.props.searchSpecialists(this.refs.postalCode.value.trim());
        this.props.clickTracking('submit', 'Search');
    },

    handleClickTracking: function(e){
        this.props.clickTracking('Click', 'Search');
    },

    render: function(){
        return (
            <form id="searchForm" onSubmit={this.handleSubmit}>
                <input id="postalcode" name="postalcode" ref="postalCode" type="text" required maxLength="10" placeholder="ZIP Code" autoComplete="off" />
                <button className="button success" type="submit" onClick={this.handleClickTracking}><span className="ion-search"></span>Search</button>
            </form>
        )
    }
});

module.exports = SearchForm;



// WEBPACK FOOTER //
// ./src/common/routes/find-a-specialist/components/layout/searchForm.jsx